export const API_DIRECTORY_THEME = {
  DEALER_API_DIRECTORY: "dealerApiDirectory",
  ISV_API_DIRECTORY: "isvApiDirectory"
};

export const THEME_COLORS = {
  [API_DIRECTORY_THEME.DEALER_API_DIRECTORY]: {
    primary: "#196FE1",
    secondary: "#E8F1FC"
  },
  [API_DIRECTORY_THEME.ISV_API_DIRECTORY]: {
    primary: "#6b2574",
    secondary: "#f0e9f1"
  }
};

export const THEME_FONTS = {
  [API_DIRECTORY_THEME.DEALER_API_DIRECTORY]: {
    primary: "Roboto",
    secondary: "Roboto"
  },
  [API_DIRECTORY_THEME.ISV_API_DIRECTORY]: {
    primary: "Montserrat, Roboto",
    secondary: "'Open Sans', Roboto"
  }
};

export const API_VISIBILITY = {
  PUBLIC: "public",
  PRIVATE: "private"
};

export const DOC_TABLE_TYPE = {
  API: "api",
  BUNDLE: "bundle"
};

export const CONTRACT_TEXT = "Contracted Off Platform";

export const BUNDLE_TYPE = {
  PRICE: "price",
  GENERAL: "general"
};

export const RESOURCE_TYPE = {
  API: "api",
  BUNDLE: "bundle"
};
export const SCROLL_DELAY_MS = 200;
